<template>
  <div class="dialog-scroll">
    <div class="viewable-area-style">
      <el-dialog
        class="search-popup"
        :visible.sync="dialogVisible"
        :before-close="handleDialogClose">

        <div class="header-style" style="margin-top: 20px;">
          <div class="title-style">
            作成するサイネージの種別を選択
          </div>
        </div>

        <div style="display: flex;">
          <div>
            <div @click="clickToNextPage('01')" :class="envSelectShowFlag ? '' : 'no-click-div'" style="cursor: pointer;">
              <div class="img-div"><img :src="envPageImg"/></div>
              <div class="img-click-div"><span>マップ</span><span class="margin-left-16">環境可視化ページを表示します</span></div>
            </div>
            <div @click="clickToNextPage('03')" :class="meetingSelectShowFlag ? '' : 'no-click-div'" style="margin-top: 32px; cursor: pointer;">
              <div class="img-div"><img :src="meetingNoImageImg"/></div>
              <div class="img-click-div"><span>リスト（画像なし）</span><span class="margin-left-16">施設の予約情報を表示します。</span></div>
            </div>
          </div>

          <div>
            <div @click="clickToNextPage('02')" :class="meetingSelectShowFlag ? '' : 'no-click-div'" style="cursor: pointer;">
              <div class="img-div"><img :src="meetingImageImg"/></div>
              <div class="img-click-div"><span>リスト（画像あり）</span><span class="margin-left-16">施設の予約情報を表示します。</span></div>
            </div>
            <div @click="clickToNextPage('04')" :class="meetingSelectShowFlag ? '' : 'no-click-div'" style="margin-top: 32px;cursor: pointer;">
              <div class="img-div"><img :src="calendarImg"/></div>
              <div class="img-click-div"><span>カレンダー</span><span class="margin-left-16">施設の予約情報を表示します</span></div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>

  </div>
</template>

<script>

export default {
  props: {
    visible: Boolean
  },
  data: function () {
    return {
      envSelectShowFlag: false,
      meetingSelectShowFlag: false,
      searchResultShowFlag: true,
      dialogVisible: this.visible,
      showSelectFloorDialog: false,
      query: {
        ownerId: null,
        ownerExId: null,
        ownerName: null,
        buildingId: null,
        buildingExId: null,
        buildingName: null,
        floorId: null,
        floor: null
      },
      envPageImg: require('@/assets/visualPageManagementType/map-visual-page-management.svg'),
      meetingNoImageImg: require('@/assets/visualPageManagementType/list-no-image-reserve.svg'),
      meetingImageImg: require('@/assets/visualPageManagementType/list-image-reserve.svg'),
      calendarImg: require('@/assets/visualPageManagementType/calendar-reserve.svg'),
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (this.$checkFuncCode("020100")) {
        this.meetingSelectShowFlag = true
      } else {
        this.meetingSelectShowFlag = false
      }

      if (this.$checkFuncCode("060140")) {
        this.envSelectShowFlag = true
      } else {
        this.envSelectShowFlag = false
      }
    }
  },
  methods: {
    cancel () {
      this.handleDialogClose()
    },

    // Dialog閉じる
    handleDialogClose () {
      this.dialogVisible = false
      this.$emit("update:visible", false)
    },

    clickToNextPage (type) {
      if (type == "01") {
        if (!this.envSelectShowFlag) {
          return
        }
      } else {
        if (!this.meetingSelectShowFlag) {
          return
        }
      }
      this.$router.push({
        name: "page-management-create",
        params: {
          type: type
        }
      })
    }

  }
};
</script>

<style lang="scss" scoped>
.search-popup {
  ::v-deep  .el-dialog {
    min-width: 1024px;
    height: 700px;
    background-color: #f2f2ed;
    border-radius: 3px !important;
    ::v-deep .el-dialog__header {
      height: 50px;
      ::v-deep .el-dialog__body {
        padding: 0px 24px 0px 19px;
      }
    }
  }
}

.cancel-button-div {
  width: 16px;
  height: 16px;
  border: 2px 0px 0px 0px;
}

.cancel-button-div.click-item {
  cursor: pointer;
}

.viewable-area-style ::v-deep .el-dialog {
  padding-top: 0px !important;
}
.header-style {
  height: 72px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex {
  display: flex;
  align-items: center;
}

.m-r-16 {
  margin-right: 16px;
}
.title-style {
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 24px;
  font-weight: 300;
  color: #525250;
}
.img-div {
  width: 410px;
  height: 229px;
  left: 542px;
  gap: 0px;
  border-radius: 8px 0px 0px 0px;
  margin-left: 45px;
}
.img-click-div {
  margin-top: 12px;
  margin-left: 45px;
}

.no-click-div {
  cursor: not-allowed !important;
}

.margin-left-16 {
  margin-left: 16px;
}
</style>
